import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectCateringCartFilters, selectCateringCartPackages } from "../../redux/features/restaurants/restaurantSelectors";
import { setCateringCartFilters } from "../../redux/features/restaurants/restaurantSlice";
import TimeSlotSelector from "./TimeSlotSelector";
import { getTodayDate, isDateBlocked } from "../../utils/timeSlots";

const PackageDetailFilterBar = ({ selectedPackage, isModifyOrderMode = false, modifyOrderPax = 0 }) => {
  const dispatch = useDispatch();
  const filters = useSelector(selectCateringCartFilters);
  const cateringCartPackages = useSelector(selectCateringCartPackages);
  const today = getTodayDate();

  // Create package data object for the selected package
  const packageData = selectedPackage ? {
    cutt_off_time_in_hours: selectedPackage.cutt_off_time_in_hours,
    unavailability_schedule: selectedPackage.unavailability_schedule || []
  } : null;

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    
    // Check if the selected date is blocked by the selected package constraints
    if (packageData && isDateBlocked(selectedDate, today, packageData)) {
      // Check if it's due to cutoff time
      if (packageData.cutt_off_time_in_hours) {
        const cutoffHours = parseInt(packageData.cutt_off_time_in_hours.match(/(\d+)/)?.[1] || '0');
        if (selectedDate === today) {
          alert(`This date is not available for booking. Orders must be placed at least ${cutoffHours} hours in advance.`);
        } else {
          alert('This date is not available for booking due to cutoff time requirements.');
        }
      } else {
        alert('This date is not available for booking due to unavailability schedule.');
      }
      return;
    }
    
    // Clear time selection when date changes to ensure valid time slot selection
    dispatch(setCateringCartFilters({ ...filters, date: selectedDate, time: "" }));
  };

  return (
    <div className="flex items-center gap-6 px-6 py-4 bg-white border-b border-gray-200">
      <div className="flex items-center gap-4">
        <span className="font-bold text-lg text-gray-400">Date</span>
        <input
          type="date"
          className="border border-gray-300 rounded-lg px-3 py-2 text-gray-500 font-bold w-40"
          value={filters.date || ""}
          onChange={handleDateChange}
          min={today}
        />
      </div>
      
      <TimeSlotSelector selectedPackage={selectedPackage} />
    </div>
  );
};

export default PackageDetailFilterBar;
